module.exports = __webpack_public_path__ + "img/cave-v1-blurred.aad606f1.jpg";